export default __webpack_public_path__ + "static/media/6.63caa9e1.svg";